import { z } from 'src/lib';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';
import { ADLClienteTipo } from './enum';
import { OperacionADLFields } from './fields';

const booleanTransform = (valor: any) => {
  if (typeof valor === 'boolean') return valor;
  if (valor == 1) return true;
  if (valor == 2) return false;
  return null;
};

const schemaBooleanADL = z.preprocess(booleanTransform, z.boolean({
  invalid_type_error: "Requerido"
}));

const schemaBooleanADLNullable = z.preprocess(booleanTransform, z.boolean().nullable().optional());

export const schemaOperacionADLInsert = z.object({
  [OperacionADLFields.CodPais]: z.number(),
  [OperacionADLFields.CodUnidadNegocio]: z.number(),
  [OperacionADLFields.CodSectorComercial]: z.number(),
  [OperacionADLFields.FechaSolicitud]: z.date(),

  [OperacionADLFields.RazonSocial]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.CodClienteTipo]: z.number(),
  [OperacionADLFields.NroCuenta]: z.string().nullable().optional(),
  [OperacionADLFields.CodLegislacionTipo]: z.number(),
  [OperacionADLFields.EntidadPuenteAcreedora]: z.string().min(1, 'Requerido'),

  [OperacionADLFields.Moneda]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.Monto]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.ComisionEstructuracion]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.TasaInteres]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.Plazo]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.TipoAmortizacionCapital]: z.string().min(1, 'Requerido'),
  [OperacionADLFields.FrecuenciaPagoInteres]: z.string().min(1, 'Requerido'),

  [OperacionADLFields.Garantias]: schemaBooleanADL,
  [OperacionADLFields.DetalleGarantias]: z.string().nullable().optional(),
  [OperacionADLFields.DetalleAforo]: z.string().nullable().optional(),
  [OperacionADLFields.Precancelable]: schemaBooleanADL,
  [OperacionADLFields.CondicionesPrecancelacion]: schemaBooleanADLNullable,

  [FilePutFields.File]: z.instanceof(File).optional().nullable(),
  [OperacionADLFields.CodVirtualCliente]: z.number().optional().nullable(),

}).superRefine((data, ctx) => {
    
    // si es Cliente nro de cuenta es obligatorio
    if (data[OperacionADLFields.CodVirtualCliente] === ADLClienteTipo.Cliente) {
        if (!data[OperacionADLFields.NroCuenta]?.trim()) {
            Validar(ctx, OperacionADLFields.NroCuenta, "El número de cuenta es obligatorio");
        }
    }

    // validaciones condicionales de garantias
    if (data[OperacionADLFields.Garantias] === true) {
        if (!data[OperacionADLFields.DetalleGarantias]?.trim()) {
            Validar(ctx, OperacionADLFields.DetalleGarantias);
        }
        if (!data[OperacionADLFields.DetalleAforo]?.trim()) {
            Validar(ctx, OperacionADLFields.DetalleAforo);
        }
    }

    // validaciones condiconales de precancelable
    if (data[OperacionADLFields.Precancelable] === true) {
        if (data[OperacionADLFields.CondicionesPrecancelacion] === null || data[OperacionADLFields.CondicionesPrecancelacion] === undefined) {
            Validar(ctx, OperacionADLFields.CondicionesPrecancelacion);
        }
    }
});

export const Validar = (ctx: any, campo: string, message?: string) => {
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: message || "Campo requerido",
    path: [campo],
  });
};

export type OperacionADLInsert = z.infer<typeof schemaOperacionADLInsert>;